import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SchemaType } from './SendBespokeInvoiceForm.schema'

export interface SendBespokeInvoiceFormFieldsProps {}

export const SendBespokeInvoiceFormFields: React.FC<SendBespokeInvoiceFormFieldsProps> = ({}) => {
  const { setValue, control } = useFormContext<SchemaType>()

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="value_date"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Date</FormLabel>
              <DatePicker
                placeholder={'Select a date...'}
                selected={value ? new Date(value) : undefined}
                onSelect={(date) =>
                  // @ts-ignore
                  setValue('value_date', date ? toISO8601(date) : undefined, {
                    shouldValidate: true,
                  })
                }
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
